
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/especialistas",
      function () {
        return require("private-next-pages/especialistas/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/especialistas"])
      });
    }
  